import {
    defaultBaseQuery,
    transformErrorResponse,
    transformSuccessResponse,
    buildFormData
} from '@/services';
import { createApi } from '@reduxjs/toolkit/query/react';

const studentJobPostApi = createApi({
    baseQuery: defaultBaseQuery,
    reducerPath: 'studentJobPostApi',
    endpoints: (builder) => ({

        getStudentJobPosts: builder.query({
            query: ({ page = 0, size = 10, searchText = '' } = {}) => ({
                url: '/placements/student/job-posts',
                method: 'GET',
                params: { page, size, ...(searchText && { searchText }) }
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getStudentJobPostById: builder.query({
            query: (id) => ({
                url: `/placements/student/job-posts/${id}`,
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        // Apply for Placement — student details (basicDetailsInfoDTO + academicRecordDTO)
        getStudentRegisterInfo: builder.query({
            query: () => ({
                url: '/sreg/student/register',
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        // Apply for Placement — skill certificates (soft skills)
        getStudentCertificates: builder.query({
            query: () => ({
                url: '/ssp/student/certificates',
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        // Apply for Placement — job oriented skills
        getStudentJobSkills: builder.query({
            query: () => ({
                url: '/ssp/student/skills/job-skills',
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        // System-generated resume — Skill Passport profile (studentProfile + academicDetails + certificates)
        getSkillPassportDashboard: builder.query({
            query: () => ({
                url: '/ssp/student/dashboard',
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        // System-generated resume — profile photo (call with { isRawResponse, skipErrorToast }: a student may have none)
        getSkillPassportProfilePhoto: builder.query({
            query: () => ({
                url: '/ssp/student/profile-photo',
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        // Single + bulk apply (multipart: JSON "data" { postIds } + optional custom resume "file")
        applyForJobPost: builder.mutation({
            query: ({ data, file }) => ({
                url: '/placements/student/bulk-apply',
                method: 'POST',
                body: buildFormData({ data: JSON.stringify(data), file })
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
    }),
});

export const {
    useLazyGetStudentJobPostsQuery,
    useLazyGetStudentJobPostByIdQuery,
    useLazyGetStudentRegisterInfoQuery,
    useLazyGetStudentCertificatesQuery,
    useLazyGetStudentJobSkillsQuery,
    useLazyGetSkillPassportDashboardQuery,
    useLazyGetSkillPassportProfilePhotoQuery,
    useApplyForJobPostMutation,
} = studentJobPostApi;

export default studentJobPostApi;
